import { z } from 'zod'

export const RunBudgetSchema = z.number().finite().min(0).max(1_000_000)
const TimezoneSchema = z.string().min(1).refine(value => {
  try { new Intl.DateTimeFormat('en-US', { timeZone: value }).format(); return true } catch { return false }
}, 'Choose a valid timezone')
export const TestingScheduleInputSchema = z.object({
  name: z.string().trim().min(1).max(100),
  enabled: z.boolean().default(true),
  cadence: z.enum(['hourly', 'daily', 'weekly', 'monthly']),
  hour: z.number().int().min(0).max(23),
  minute: z.number().int().min(0).max(59).refine(value => value % 15 === 0, 'Choose a quarter-hour'),
  weekday: z.number().int().min(0).max(6).default(0),
  month_day: z.number().int().min(1).max(28).default(1),
  timezone: TimezoneSchema,
  budget: RunBudgetSchema,
  monthly_budget: RunBudgetSchema.nullable().default(null),
  target: z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('journeys'), journey_ids: z.array(z.string().min(1)).max(500).nullable(), environment_id: z.string().min(1).nullable() }).strict(),
    z.object({ kind: z.literal('exploration'), prompt: z.string().trim().min(1).max(10_000), source_exploration_id: z.string().min(1).nullable() }).strict(),
  ]),
}).strict().refine(value => value.target.kind !== 'exploration' || value.budget >= 1, 'An exploration needs a budget of at least 1 credit')
export type TestingScheduleInput = z.infer<typeof TestingScheduleInputSchema>
export const TestingScheduleSchema = z.object({
  id: z.string(), project_id: z.string(), config: TestingScheduleInputSchema,
  last_occurrence: z.string().nullable(),
})
export const TestingScheduleRunSchema = z.object({
  id: z.string(), schedule_id: z.string(), occurrence: z.string(),
  status: z.enum(['pending', 'dispatching', 'queued', 'skipped', 'failed']),
  budget: z.number(), detail: z.string().nullable(),
})
export const TestingSchedulesResponseSchema = z.object({ schedules: z.array(TestingScheduleSchema), runs: z.array(TestingScheduleRunSchema) })
export const TestingScheduleMutationSchema = z.object({ schedule: TestingScheduleSchema })
export type TestingSchedule = z.infer<typeof TestingScheduleSchema>

export const TestingSetupPlanSchema = z.object({ plan_key: z.string().nullable() })
